module.exports = "https://cdn.thelire.com/ins/resource/ico_tab5_24personalconsultant@3x.faba9ff4482c1cccc4d3e207f723dfb2.png";